import React from "react";
import { withRouter } from "react-router";
import { PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw";
import { MessageUtil } from '../../../../../util/MessageUtil';     
import { LoadUtil } from "../../../../../framework/util/LoadUtil"; 
import { EnvConstants } from "../../../../../EnvConstants";
 import { DATE_FORMAT } from '../../../../../constants/constants';
 import { DateUtil } from '../../../../../util/DateUtil';
import { UserUtil } from "../../../../../util/UserUtil";
import { BasePage } from "../../../../../framework/pages/BasePage";


class DatosEnvioMuestraSection extends BasePage {
   renderPage(pageApi) {
    const getForm_datos_envio_muestra = () => pageApi.getComponent('form_datosenviomuestra');
     
    let Forma_envio = 1 

 
    
    const form_datos_envio_muestra = {
      layout: 'vertical',
        load:{
          queryId: 815,
          search: true,
          hideMessage: true,
          hideMessageError: true, 
          params: { id_doc: pageApi.getParamId() }
        },
        save: { 
          queryId: 834, 
          hideMessage: true,
          hideMessageError: true, 
          params: { est_tab : 5,id_SS : pageApi.getParamId(), id_user: UserUtil.getUserId()},
          fnOk: (resp) => {
              const id_doc = resp.dataObject?.id_doc;   
              const est_tab_actual = resp.dataObject?.est_tab;    

              if(est_tab_actual == 5){
              this.props.history.push(`/servicios-ejecutados/servicios-ejecutados/5/${id_doc}`)
              }
              
              this.props.cambiarTabPanel("5",id_doc); 
              return MessageUtil(
              "success",
              "Exito!",
              "Se ha habilitado Datos de Emision de Informe y Factura"
              ); 
          }, 
        },
        title: '',
        //collapsible: true,
        fields:[
          {
              label: '  ',
              fields: [
                { name: "titulo", label: "Nro. Solicitud", column: 1, readOnly: true },  
                {type: 'hidden', name: 'id_doc'},    
                {type: 'select', name:'forma_envio', label:'Forma de Envio', column: 10, value: 1,
                    load: {
                        dataList: [
                            {label: 'Envio por parte del cliente', value: 1},
                            {label: 'Solicitar recojo de muestras', value: 2}
                        ]
                    },
                    onChange: (value) => { 
                        if(value == 2){
                          Forma_envio = 2
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[15].setVisible(true); 
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[16].setVisible(true); 
                         
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[4].setVisible(true); 
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[5].setVisible(false); 

                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[8].setVisible(false); 
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[9].setVisible(true); 
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[10].setVisible(true); 
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[11].setVisible(false);  
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[12].setVisible(false);  
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[13].setVisible(false);  
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[14].setVisible(false);  
                          }
                        else{  
                          Forma_envio = 1 
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[4].setVisible(false); 
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[5].setVisible(true); 
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[8].setVisible(true);   
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[11].setVisible(false);   
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[12].setVisible(false);   
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[13].setVisible(false);   
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[14].setVisible(false);   
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[15].setVisible(false);     
                            getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[16].setVisible(false); 
                        }
                      
                    }, 
                }, 
        
                  { type: "select", name: "id_origen", label: "Origen", column: 5, load: { queryId: 818 }, search: true, },  
                  {type: 'date', name:'fecha_recojo', label: 'Fecha de Recojo',column: 5, format: 'DD/MM/YYYY',inputFormat: DATE_FORMAT.YYYYMMDD, value: DateUtil.getDate},
                  {type: 'date', name:'fecha_recojo', label: 'Fecha de Envio',column: 5, format: 'DD/MM/YYYY',inputFormat: DATE_FORMAT.YYYYMMDD, value: DateUtil.getDate},
                  { type: "select", name: "id_destino", label: "Destino", column: 5, load: { queryId: 818 }, search: true, },  
                  {type: 'date', name:'fecha_prog_llegada', label: 'Fecha Prog Llegada',column: 5, format: 'DD/MM/YYYY',inputFormat: DATE_FORMAT.YYYYMMDD, value: DateUtil.getDate},
                  { type: "select", name: "id_tipo_envio", label: "Tipo de Envio", column: 5, load: { queryId: 819 }, 
                  search: true,  
                          onChange:(value, values, formApi) => {

                             if (Forma_envio == 1){
                                if(value == 1 || value == 3){
                                    getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[9].setVisible(true); 
                                    getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[10].setVisible(true); 
                              
                                
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[11].setVisible(false);  
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[12].setVisible(false);  
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[13].setVisible(false);  
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[14].setVisible(false);  
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[15].setVisible(false);  
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[16].setVisible(false);  
                                  }
                                else{   

                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[4].setVisible(false); 
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[5].setVisible(true); 


                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[9].setVisible(false); 
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[10].setVisible(false);  
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[11].setVisible(true);  
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[12].setVisible(true);  
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[13].setVisible(true);  
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[14].setVisible(true); 
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[15].setVisible(false);  
                                  getForm_datos_envio_muestra()?.getConfig()?.fields[0].fields[16].setVisible(false);   
                                }
                              } 
                          } 
                  },  
                  { type: "select", name: "id_direccion_destino", label: "Direccion destino", column: 5, load: { queryId: 820 }, search: true, },     
                  { name: "courier", label: "Courier: ", column: 5,}, 
                  { name: "envio_nombre", label: "Envio a nombre de: ", column: 5,},  
                  { name: "courier_recojo", label: "Courier: ", column: 5,}, 
                  { name: "direccion_recojo", label: "Direccion de Recojo: ", column: 5,}, 
                  { name: "clave_recojo", label: "Clave para recojo: ", column: 5,},
                  
                  { name: "dir_recojo_muestras", label: "Direccion de Recojo: ", column: 5,}, 
                  { type: "select", name: "id_lab_destino", label: "Laboratorio destino", column: 5, load: { queryId: 820 }, search: true, }

                
              ]   
          }
      ],
      onComponentLoad : (formApi, pageApi) =>{
          if (pageApi.getPageMode() !== PAGE_MODE.NEW)
              formApi.load();
      } 
    }
 
    const barButtonFooter = {
        fields: [
            { ...BUTTON_DEFAULT.RETURN, link: () => {
                const path = sessionStorage.getItem("ruta_retorno_ejecutar_servicio");
                sessionStorage.removeItem("ruta_retorno_ejecutar_servicio")
                return path;
            }, alert: true, message: 'Está seguro de retornar?', },
            { ...BUTTON_DEFAULT.SAVE, label: "Guardar y Continuar",onClick: () => { getForm_datos_envio_muestra().save() } }, 
        ]
    }
  
    return (
      <>
        <FormFw
          name="form_datosenviomuestra"
          getParentApi={pageApi.getApi}
          config={form_datos_envio_muestra} 
        />
 
        <BarButtonFw 
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooter} 
        /> 
      </>
    ); 
  } 
} 
export default DatosEnvioMuestraSection